const ONE_MINUTE_MS = 60 * 1000;
const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
const EIGHT_HOURS_MS = 8 * ONE_HOUR_MS;

export {
  ONE_MINUTE_MS,
  ONE_HOUR_MS,
  EIGHT_HOURS_MS,
}
